import {
  buildCandidateOpportunityMatchPath,
  buildEmployerPersonMatchPath,
  buildRecruiterPersonMatchPath,
} from '@/lib/match-detail-paths'

export type EvaluationAnalysisContext =
  | { kind: 'employer-job'; jobId: string }
  | { kind: 'recruiter-talent' }
  | { kind: 'recruiter-brief'; briefId: string }
  | { kind: 'candidate-jobs' }

export function buildEvaluationAnalysisPath(
  context: EvaluationAnalysisContext,
  evaluationId: string,
  profileId?: string,
): string {
  switch (context.kind) {
    case 'employer-job':
      if (profileId) {
        return buildEmployerPersonMatchPath(context.jobId, profileId, {
          evaluationId,
          tab: 'analysis',
        })
      }
      return `/employer/jobs/${encodeURIComponent(context.jobId)}/talent/${encodeURIComponent(evaluationId)}`
    case 'recruiter-talent':
      if (profileId) {
        return buildRecruiterPersonMatchPath(profileId, {
          evaluationId,
          tab: 'analysis',
        })
      }
      return `/recruiter/talent/analysis/${encodeURIComponent(evaluationId)}`
    case 'recruiter-brief':
      if (profileId) {
        return buildRecruiterPersonMatchPath(profileId, {
          briefId: context.briefId,
          evaluationId,
          tab: 'analysis',
        })
      }
      return `/recruiter/talent/analysis/${encodeURIComponent(evaluationId)}`
    case 'candidate-jobs':
      return buildCandidateOpportunityMatchPath(evaluationId, { tab: 'analysis' })
  }
}

export function buildEvaluationAnalysisBackPath(context: EvaluationAnalysisContext): string {
  switch (context.kind) {
    case 'employer-job':
      return `/employer/jobs/${encodeURIComponent(context.jobId)}/talent`
    case 'recruiter-talent':
      return '/recruiter/talent?tab=search'
    case 'recruiter-brief':
      return `/recruiter/briefs/${encodeURIComponent(context.briefId)}?tab=search`
    case 'candidate-jobs':
      return '/candidate/jobs?tab=saved'
  }
}

export function evaluationAnalysisBackLabel(context: EvaluationAnalysisContext): string {
  switch (context.kind) {
    case 'employer-job':
      return 'Back to talent'
    case 'recruiter-talent':
      return 'Back to analysis'
    case 'recruiter-brief':
      return 'Back to brief analysis'
    case 'candidate-jobs':
      return 'Back to saved jobs'
  }
}

export type OpenPersonMatchHandler = (
  profileId: string,
  label: string,
  evaluationId?: string | null,
) => void

export type OpenOpportunityMatchHandler = (
  evaluationId: string,
  label: string,
  opportunityId?: string,
) => void
